import Vue, { PluginObject, VueConstructor } from 'vue'
import Vuelidate from 'vuelidate'

Vue.use(Vuelidate);